import React from "react";
import styled from "styled-components";
import { getFlexCenter } from "../../styles";
import LoadingSpinner from "../LoadingSpinner";

const SpinnerWrapper = styled.div`
  width: 100%;
  ${getFlexCenter};
  padding: 32px 0;
`;

const InfinityListLoader = () => {
  return (
    <SpinnerWrapper>
      <LoadingSpinner />
    </SpinnerWrapper>
  );
};

export default InfinityListLoader;
